export const QuotationLabel = {
  QuotationTitle: "Quotation",
  NewQuotation: "New Quotation",
  EditQuotation: "Edit Quotation",
  ViewQuotation:"View Quotation",
  VendorId: "Customer ID",
  VendorName: "Customer Name",
  QuoteNo: "Quote No",
  QuoteValue: "Quote Value",
  QuoteAmt: "Quote Amt.",
  QuoteAmtInc: "Quote Amt(Inc of tax)",
  Status: "Status",
  QuoteDate: "Quote Date",
  Consignee: "Consignee (Ship to)",
  ConsigneeAddress1: "Consignee Address1",
  ConsigneeAddress2: "Consignee Address2",
  ConsigneePostal: "Consignee Postal",
  ConsigneeCity: "Consignee City",
  ConsigneeState: "Consignee State",
  ConsigneeCountry: "Consignee Country",
  Buyer: "Buyer (Bill to)",
  BuyerAddress1: "Buyer Address1",
  BuyerAddress2: "Buyer Address2",
  BuyerPostal: "Buyer Postal",
  BuyerCity: "Buyer City",
  BuyerState: "Buyer State",
  BuyerCountry: "Buyer Country",
  Dated: "Dated",
  ModesOfPayment: "Mode/Terms Of Payment",
  BuyerRefNo: "Buyer's Ref./Order No",
  BuyerRefDate: "Buyer's Ref./Order Date",
  VehicleRegNo: "Vehicle Reg./VDN No.",
  ChassisNo: "Chassis/Serial No.",
  EngineNo: "Engine No",
  Destination: "Destination",
  Warranty: "Warranty",
  OtherRef: "Other Reference",
  TermsOfDelivery: "Terms of Delivery",
  ProductField: "Product Field",
  SrNo: "Sr. No",
  DescriptionOfGoods: "Description of Goods and service",
  DescriptionSubHead: "Description Sub Head",
  HSN_SAC: "HSN/SAC",
  GST: "GST",
  Quantity: "Quantity",
  Rate: "Rate",
  Per: "UOM",
  Amount: "Amount",
  GstAmount: "GST Amount",
  Product: "Product",
  Approved: "Approved",
  Pending: "Pending",
  Rejected: "Rejected",
  Approve: "Approve",
  Reject: "Reject",
  Recheck: "Recheck",
  Publish: "Publish",
  EditStatus: "Edit Status",
  ProductName: "Product Name",
  Discount: "Discount",
  View:"View",
  TotalAmount: "Taxable Value",
  TotalGSTAmount: "Total Amount",
  TableError: "Please fill all required fields in the table.",
  Remarks: "Remarks",
  AddHsn: "AddHSN",
  AddNewHsn:"Add HSN/SAC",
  AddProduct: "Add Product",
  AddCustomer: "Add Customer",
  BasicDetails: "Basic Details",
  AdditionalDetails: "Additional Details",
  ProductImage: "Product Images",
  Service: "Service",
  ServiceName: "Service Name",
  AddService: "Add Service",
};

export const QuotationKey = {
  VendorId: "customer_id",
  VendorName: "customer_name",
  QuoteNo: "quotation_number",
  QuoteValue: "quote_value",
  QuoteAmt: "with_gst_amount",
  Status: "status",
  QuoteDate: "quotation_date",
  GST: "gst",
  SrNo: "sr_no",
  ProductName: "product_name",
  ServiceName: "service_name",
  DescriptionOfGoods: "description",
  DescriptionSubHead: "sub_description",
  HSN_SAC: "hsn_sac_code",
  QuotationGst: "gst",
  Quantity: "quantity",
  Rate: "rate",
  Per: "uom",
  Amount: "amount",
  GstAmount: "gst_amount",
  Discount: "discount",
  Remarks: "remarks",
};
